import { Host, h } from '@stencil/core';
export class AibaAnalysisTab {
  constructor() {
    this.componentWillLoad = async () => {
      if (this.handlers && this.handlers.handleAnalysisTabLoad) {
        let dataFromViewLoad = await this.handlers.handleAnalysisTabLoad();
        if (dataFromViewLoad) {
          this.skinData = dataFromViewLoad;
        }
      }
    };
    this.data = undefined;
    this.handlers = undefined;
    this.isCompare = true;
    this.skinPropData = {};
    this.skinData = this.skinPropData;
    this.selectedAgeGroup = undefined;
  }
  ageRangeChangeEventHandler(data) {
    var _a;
    this.skinData = data.detail.skinData;
    this.selectedAgeGroup = (_a = data === null || data === void 0 ? void 0 : data.detail) === null || _a === void 0 ? void 0 : _a.selectedAgeGroup;
  }
  render() {
    var _a, _b;
    return (h(Host, null, h("div", { class: "analysis-tab-wrapper" }, this.data &&
      ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.elements.map((element) => {
        if (element.name === 'analysis-tab-header') {
          return (h("div", { class: "analysis-tab-header" }, element.data.elements.map((item) => {
            return item.name === 'aiba-label' && h("aiba-label", Object.assign({}, item['data']));
          })));
        }
        if (element.name === 'skin-progress-bar-wizard') {
          return (h("div", { class: "skin-progress-bar-wizard-wrapper" }, element.data.elements.map((item) => {
            if (item.name === 'skin-progress-bar-header') {
              return (h("div", { class: "skin-progress-bar-header" }, item.data &&
                item.data.elements.map((element) => {
                  if (element.name === 'aiba-label') {
                    return h("aiba-label", Object.assign({}, element['data']));
                  }
                })));
            }
            if (item.name === 'skin-progress-bar') {
              return this.skinData.data.map((skinData) => {
                return (h("div", { class: "skin-progress-bar-wrapper" }, item.data &&
                  item.data.elements.map((element) => {
                    if (element.name === 'aiba-label' && element._id === 'algorithmTechName')
                      return h("aiba-label", { tag: element.data.tag, text: skinData.algorithmTechName });
                    if (element.name === 'aiba-progress-bar') {
                      return (h("div", { class: "aiba-progress-bar-wrapper" }, h("div", { class: "progress-score" }, h("aiba-progress-bar", { progress: skinData.score, status: skinData.status })), this.isCompare && skinData.compareScore && (h("div", { class: "progress-compare" }, h("aiba-progress-bar", { progress: skinData.compareScore, status: skinData.compareStatus })))));
                    }
                    if (element.name === 'aiba-label' && element._id === 'status') {
                      return (h("div", { class: "status" }, h("div", { class: "status-score" }, h("aiba-label", { classes: element.data.classes ? element.data.classes : 'text-align-center-sm', tag: element.data.tag, text: `${skinData.score}` })), this.isCompare && skinData.compareScore && (h("div", { class: "compare-score-status" }, h("aiba-label", { classes: element.data.classes ? element.data.classes : 'text-align-center-sm compare-label', tag: element.data.tag, text: `${skinData.compareScore}` })))));
                    }
                  })));
              });
            }
            if (item.name === 'legends') {
              return (h("div", { class: "legends-wrapper" }, item.data.elements.map((element) => {
                if (element.name === 'aiba-legend') {
                  return h("aiba-legend", Object.assign({}, element, { data: element['data'] }));
                }
              }), this.selectedAgeGroup && h("aiba-legend", { renderWithoutData: true, customVariant: "age", text: `${this.selectedAgeGroup}` })));
            }
          })));
        }
        if (element.name === 'aiba-age-compare') {
          return h("aiba-age-compare", { data: element['data'], handlers: this.handlers });
        }
        if (element.name === 'aiba-social-media-share') {
          return h("aiba-social-media-share", { handlers: this.handlers, data: element['data'] });
        }
        if (element.name === 'aiba-set-goal') {
          return h("aiba-set-goal", { data: element['data'], handlers: this.handlers });
        }
      })))));
  }
  static get is() { return "aiba-analysis-tab"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-analysis-tab.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-analysis-tab.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "isCompare": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-compare",
        "reflect": false,
        "defaultValue": "true"
      },
      "skinPropData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "skin-prop-data",
        "reflect": false,
        "defaultValue": "{}"
      }
    };
  }
  static get states() {
    return {
      "skinData": {},
      "selectedAgeGroup": {}
    };
  }
  static get listeners() {
    return [{
        "name": "ageRangeChangeEvent",
        "method": "ageRangeChangeEventHandler",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-analysis-tab.js.map
